import TemplateHeader from "components/Header";
import LoadingOverlay from "components/Indicator/LoadingOverlay";
import TemplateSidemenu from "components/Menu/Sidemenu";
import TemplateContainerMain from "components/Template";
import PageTitle from "components/Title/PageTitle";
import { Component } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { Card, CardBody, Col, Row, Table, Pagination, PaginationItem, PaginationLink } from "reactstrap";
import _ from "lodash";
import { RolesPermission } from "Config";
import { compose } from "redux";
import FilterForm from "./Form.js";
import ReportAPI from "./action.js";
import { CheckUserRolesPermissons } from "actions/roles";
import { requestError } from "utils/requestHandler";

class CommissionReport extends Component {
	state = {
		filterQuery: "",
		activeQuery: "",
		currentPage: 1,
		hasSearched: false,
		resultData: null,
	};

	componentDidMount = () => {
		let tempModule = _.find(RolesPermission, {
			moduleID: CheckUserRolesPermissons(this.props.data.ProfileReducer.profile.roles).id,
		});

		if (tempModule && !tempModule.permissions.includes(13)) {
			return this.props.history.push("/");
		}
	};

	render = () => {
		const {
			onChangeHOC,
			downloadReport,
			downloadReportPdf,
			searchCommissionAgents,
			searchCommissionReport,
		} = this.props;
		const customSetState = (newState) => {
			this.setState(newState);
		};

		const handleExport = (filterQuery) => {
			downloadReport(filterQuery);
			onChangeHOC("filterQuery", filterQuery);
		};
		const handleExportPdf = (filterQuery) => {
			downloadReportPdf(filterQuery);
			onChangeHOC("filterQuery", filterQuery);
		};
		const handleSearch = (filterQuery, page = 1) => {
			if (typeof searchCommissionReport !== "function") {
				requestError("Search API is unavailable. Please refresh and try again.");
				return;
			}
			searchCommissionReport(
				filterQuery,
				page,
				(payload) => {
					this.setState({
						hasSearched: true,
						activeQuery: filterQuery,
						currentPage: page,
						resultData: payload?.data || null,
					});
					onChangeHOC("filterQuery", filterQuery);
				},
				() => {}
			);
		};

		const renderCurrency = (value) =>
			Number(value || 0).toLocaleString(undefined, {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			});
		const renderPercent = (value) =>
			`${(Number(value || 0) * 100).toLocaleString(undefined, {
				minimumFractionDigits: 0,
				maximumFractionDigits: 2,
			})}%`;
		const resultRows = this.state.resultData?.rows || [];
		const totals = this.state.resultData?.totals || {
			price_after_tax: 0,
			tax: 0,
			selling_price: 0,
			commission_payable: 0,
		};
		const pagination = this.state.resultData?.pagination || {
			count: 0,
			limit: 10,
			offset: 0,
		};
		const totalPages = Math.max(
			1,
			Math.ceil((pagination.count || 0) / (pagination.limit || 10))
		);
		const header = this.state.resultData?.header || {};

		return (
			<>
				<TemplateContainerMain>
					<TemplateHeader
						onClickToggleProfileModal={() => {}}
						history={this.props.history}
						user={this.props.data.ProfileReducer.profile}
					/>
					<div className="app-main">
						<TemplateSidemenu
							userPermissions={this.props.userPermissions}
							user={this.props.user}
							userRole={this.props.userRole}
						/>
						<div className="app-main__outer">
							<div className="app-main__inner">
								<>
									<PageTitle heading="Commission Report" />
									<ReactCSSTransitionGroup
										component="div"
										transitionName="TabsAnimation"
										transitionAppear={true}
										transitionAppearTimeout={0}
										transitionEnter={false}
										transitionLeave={false}>
										<Row>
											<Col md={12} style={{ minWidth: "max-content" }}>
												<Card className="main-card mb-3">
													<CardBody>
														<FilterForm
															onSubmit={handleSearch}
															onExport={handleExport}
															onExportPdf={handleExportPdf}
															onChangeHOC={onChangeHOC}
															handleState={customSetState}
															searchCommissionAgents={searchCommissionAgents}
														/>
													</CardBody>
												</Card>
											</Col>
										</Row>
										{this.state.hasSearched && (
											<Row>
												<Col md={12}>
													<Card className="main-card mb-3">
														<CardBody>
															<div className="mb-3">
																<div style={{ fontWeight: 700 }}>
																	{header.company_name || "THE CHINA PRESS BERHAD - JOBMACHA"}
																</div>
																<div style={{ height: 16 }} />
																<div
																	style={{
																		display: "grid",
																		gridTemplateColumns: "repeat(8, 1fr)",
																		alignItems: "center",
																	}}>
																	<div style={{ gridColumn: "1 / span 3" }}>
																		<strong>NAME</strong>: {header.agent_name || "-"}
																	</div>
																	<div
																		className="text-center"
																		style={{ gridColumn: "4 / span 2", fontWeight: 700 }}>
																		{header.fy_label || "-"}
																	</div>
																	<div
																		className="text-right"
																		style={{ gridColumn: "7 / span 2", fontWeight: 700 }}>
																		{header.appendix_label || "Appendix 1"}
																	</div>
																</div>
																<div>
																	<strong>AGENT CODE</strong>: {header.agent_code || "-"}
																</div>
																<div>
																	<strong>{header.month_year_label || "-"}</strong>
																</div>
															</div>
															<div className="table-responsive">
																<Table bordered>
																	<thead>
																		<tr>
																			<th>Invoice Date</th>
																			<th>Invoice No.</th>
																			<th>Advertiser Name</th>
																			<th>Price After Tax (RM)</th>
																			<th>Tax (RM)</th>
																			<th>Selling Price (RM)</th>
																			<th>Commission (%)</th>
																			<th>Commission Payable (RM)</th>
																		</tr>
																	</thead>
																	<tbody>
																		{resultRows.length === 0 ? (
																			<tr>
																				<td colSpan={8} className="text-center">
																					No record
																				</td>
																			</tr>
																		) : (
																			resultRows.map((row, idx) => (
																				<tr key={`${row.invoice_no || "row"}-${idx}`}>
																					<td>
																						{row.invoice_date
																							? new Date(row.invoice_date).toLocaleDateString(
																									"en-GB"
																							  )
																							: ""}
																					</td>
																					<td>{row.invoice_no || ""}</td>
																					<td>{row.advertiser_name || ""}</td>
																					<td className="text-right">
																						{renderCurrency(row.price_after_tax)}
																					</td>
																					<td className="text-right">{renderCurrency(row.tax)}</td>
																					<td className="text-right">
																						{renderCurrency(row.selling_price)}
																					</td>
																					<td className="text-right">
																						{renderPercent(row.commission)}
																					</td>
																					<td className="text-right">
																						{renderCurrency(row.commission_payable)}
																					</td>
																				</tr>
																			))
																		)}
																		<tr style={{ fontWeight: 700 }}>
																			<td colSpan={3} className="text-right">
																				Total
																			</td>
																			<td className="text-right">
																				{renderCurrency(totals.price_after_tax)}
																			</td>
																			<td className="text-right">{renderCurrency(totals.tax)}</td>
																			<td className="text-right">
																				{renderCurrency(totals.selling_price)}
																			</td>
																			<td className="text-center">-</td>
																			<td className="text-right">
																				{renderCurrency(totals.commission_payable)}
																			</td>
																		</tr>
																	</tbody>
																</Table>
															</div>
															{pagination.count > 0 && (
																<Pagination className="mb-0">
																	<PaginationItem disabled={this.state.currentPage <= 1}>
																		<PaginationLink
																			previous
																			href="#"
																			onClick={(e) => {
																				e.preventDefault();
																				if (this.state.currentPage > 1) {
																					handleSearch(
																						this.state.activeQuery,
																						this.state.currentPage - 1
																					);
																				}
																			}}
																		/>
																	</PaginationItem>
																	{Array.from({ length: totalPages }).map((_, index) => {
																		const page = index + 1;
																		return (
																			<PaginationItem
																				key={page}
																				active={page === this.state.currentPage}>
																				<PaginationLink
																					href="#"
																					onClick={(e) => {
																						e.preventDefault();
																						handleSearch(this.state.activeQuery, page);
																					}}>
																					{page}
																				</PaginationLink>
																			</PaginationItem>
																		);
																	})}
																	<PaginationItem
																		disabled={this.state.currentPage >= totalPages}>
																		<PaginationLink
																			next
																			href="#"
																			onClick={(e) => {
																				e.preventDefault();
																				if (this.state.currentPage < totalPages) {
																					handleSearch(
																						this.state.activeQuery,
																						this.state.currentPage + 1
																					);
																				}
																			}}
																		/>
																	</PaginationItem>
																</Pagination>
															)}
														</CardBody>
													</Card>
												</Col>
											</Row>
										)}
									</ReactCSSTransitionGroup>

									{this.props.onLoad && <LoadingOverlay />}
								</>
							</div>
						</div>
					</div>
				</TemplateContainerMain>
			</>
		);
	};
}

export default compose(ReportAPI)(CommissionReport);
